import { NgModule } from '@angular/core';
import { FallimgDirective } from './fallimg.directive';

@NgModule({
  declarations: [FallimgDirective],
  exports: [FallimgDirective],
})
export class FallimgModule {}
